"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterWrapper = exports.PlayerWrapper = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var react_full_screen_1 = __importDefault(require("react-full-screen"));

var react_hotkeys_hook_1 = require("react-hotkeys-hook");

var MediaPlaybackContext_1 = require("./MediaPlaybackContext");

function PlayerWrapper(_ref) {
  var children = _ref.children,
      containerRef = _ref.containerRef;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      fullscreen = _ref2.fullscreen,
      setFullscreen = _ref2.setFullscreen,
      onSetPlaying = _ref2.onSetPlaying;

  (0, react_hotkeys_hook_1.useHotkeys)('space', function () {
    onSetPlaying(function (p) {
      return !p;
    });
  });
  return react_1.default.createElement(react_full_screen_1.default, {
    enabled: fullscreen,
    onChange: setFullscreen
  }, react_1.default.createElement(antd_1.ConfigProvider, {
    getPopupContainer: function getPopupContainer() {
      return fullscreen ? containerRef.current || document.body : document.body;
    },
    children: children
  }));
}

exports.PlayerWrapper = PlayerWrapper;

function FooterWrapper(_ref3) {
  var setOverFooter = _ref3.setOverFooter,
      children = _ref3.children;
  return react_1.default.createElement("div", {
    style: {
      pointerEvents: 'all'
    },
    onMouseEnter: function onMouseEnter() {
      return setOverFooter(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOverFooter(false);
    },
    children: children
  });
}

exports.FooterWrapper = FooterWrapper;